import { useT } from '../../i18n';

export function Footer() {
  const t = useT();
  return (
    <div className="text-center py-3" style={{ height: 16, lineHeight: '16px' }}>
      <span style={{ fontSize: 9, opacity: 0.5, color: 'var(--t-text)', letterSpacing: '0.27px' }}>
        {t('footer.poweredBy')}
      </span>
      <span style={{ fontSize: 9, opacity: 0.65, color: 'var(--t-text)', letterSpacing: '0.27px' }}>
        {t('footer.brand')}
      </span>
    </div>
  );
}
